/**
 * API Configuration
 * קובץ מרכזי לניהול כתובות API
 * 
 * הגדרת כתובות API לפי סביבה:
 * - Development (npm start): https://dev-dot-jazzit-warehouse.ew.r.appspot.com/api (שרת פיתוח בענן)
 * - Production (npm run build): https://jazzit.co.il/api
 */

const isProduction = process.env.NODE_ENV === 'production';

const getApiBaseUrl = (): string => {
  // 1) עדיפות להגדרה מפורשת בזמן build/deploy
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2) על דומיין dev/prod בענן נשתמש באותו origin וכך נמנע CORS
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isDevHost =
      host.includes('dev-dot-jazzit-warehouse.ew.r.appspot.com') ||
      host === 'dev.jazzit.co.il';
    const isProdHost = host === 'jazzit.co.il' || host === 'www.jazzit.co.il';

    if (isDevHost || isProdHost) {
      return `${window.location.origin}/api`;
    }
  }

  // 3) fallback מקומי
  return isProduction
    ? 'https://jazzit.co.il/api'
    : 'https://dev-dot-jazzit-warehouse.ew.r.appspot.com/api';
};

export const API_BASE_URL = getApiBaseUrl();

// ייצוא נוסף עם slash בסוף (לתאימות לאחור)
export const API_BASE_URL_WITH_SLASH = API_BASE_URL.endsWith('/') 
  ? API_BASE_URL 
  : `${API_BASE_URL}/`;

// פונקציה לבניית URL מלא
export const buildApiUrl = (endpoint: string): string => {
  // הסרת slash בתחילת ה-endpoint אם קיים
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL_WITH_SLASH}${cleanEndpoint}`;
};

// בדיקה אם רצים בייצור (כבר מוגדר למעלה)

// בדיקה אם רצים בפיתוח
export const isDevelopment = process.env.NODE_ENV === 'development';

// הדפסה לקונסול (תמיד, כדי לבדוק איזו כתובת מוגדרת)
console.log('🔧 API Configuration:');
console.log('  API_BASE_URL:', API_BASE_URL);
console.log('  Environment:', process.env.NODE_ENV);
console.log('  REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('  Target Environment:', isProduction ? 'PRODUCTION' : 'DEVELOPMENT');

export default API_BASE_URL;
